var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.721 61a10.832 10.832 0 0 0 4.532-.987l9.821-4.49a11 11 0 0 0 4-3.114l8.269-10.316a3.005 3.005 0 0 0-.352-4.135l-.234-.208a2.984 2.984 0 0 0-3.964.008l-9.33 8.323a8.925 8.925 0 0 1-2.614 1.624l-7.129 2.866a.982.982 0 0 1-1.064-.22l-1.013-1.02L42 46.643a1.074 1.074 0 0 0 .122-.062 6.645 6.645 0 0 0 2.317-2.33 3 3 0 0 0-3.083-4.5l-10.714 1.9a10.875 10.875 0 0 0-3.9 1.508l-3.9 2.453a8.9 8.9 0 0 1-4.742 1.372H12V46a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.1l7.158-.72a8.865 8.865 0 0 1 3.348.3l3.8 1.092a10.92 10.92 0 0 0 3.01.424zM10 60H4V47h6zm13.059-2.438a10.924 10.924 0 0 0-4.1-.369l-6.958.7v-8.909h6.1a10.89 10.89 0 0 0 5.799-1.675l3.9-2.453a8.869 8.869 0 0 1 3.187-1.232l10.715-1.9a.974.974 0 0 1 .98.412 1 1 0 0 1 .034 1.1 4.651 4.651 0 0 1-1.566 1.6l-7.65 3.229a1 1 0 0 0-.319 1.626l2.057 2.07a2.978 2.978 0 0 0 3.229.666l7.124-2.867a10.921 10.921 0 0 0 3.2-1.987l9.33-8.323a.982.982 0 0 1 1.306 0l.234.207a1.008 1.008 0 0 1 .117 1.387L51.51 51.158a9 9 0 0 1-3.267 2.542l-9.822 4.49a8.837 8.837 0 0 1-3.7.806h-5.409a8.942 8.942 0 0 1-2.458-.346z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 56h2v2H6zM15 10v26a1 1 0 0 0 1 1h32a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H16a1 1 0 0 0-1 1zm2 1h30v24H17z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.151 20.123-5-.764-2.245-4.784a1 1 0 0 0-1.81 0l-2.246 4.784-5 .764a1 1 0 0 0-.565 1.687l3.648 3.738-.864 5.291a1 1 0 0 0 1.471 1.036L32 29.41l4.461 2.465a1 1 0 0 0 1.471-1.036l-.864-5.291 3.648-3.738a1 1 0 0 0-.565-1.687zm-4.867 4.39a1 1 0 0 0-.271.859l.613 3.756-3.143-1.736a1 1 0 0 0-.966 0l-3.143 1.736.613-3.756a1 1 0 0 0-.271-.859l-2.641-2.707 3.605-.55a1 1 0 0 0 .754-.564L32 17.354l1.566 3.338a1 1 0 0 0 .754.564l3.6.55zM31 2h2v4h-2zM53 22h4v2h-4zM7 22h4v2H7zM8.877 5.294l1.414-1.414 2.828 2.828-1.414 1.414zM50.873 6.712l2.828-2.828 1.414 1.414-2.828 2.828z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrands);
export default __webpack_public_path__ + "static/media/brands.70796186bcfd878c3632c215af137999.svg";
export { ForwardRef as ReactComponent };